import React from "react";
import { Box, Typography } from "@mui/material";

const EnterpriseManagement = () => {
  const isEnterprise = localStorage.getItem("isEnterprise") === "yes";

  if (!isEnterprise) {
    return (
      <Box sx={{ p: { xs: 2, md: 4 } }}>
        <Typography variant="h6" color="error">
          Enterprise access is required to view this page.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <Box
        sx={{
          maxWidth: 900,
          mx: "auto",
          p: { xs: 3, md: 4 },
          borderRadius: 3,
          bgcolor: "white",
          boxShadow: "0 18px 45px rgba(15, 23, 42, 0.08)",
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
          Enterprise Management
        </Typography>
        <Typography color="text.secondary">
          Enterprise management tools will be available here soon.
        </Typography>
      </Box>
    </Box>
  );
};

export default EnterpriseManagement;
